import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { styled } from '@mui/material/styles';
import useResponsive from '../../hooks/useResponsive';
import Header from './header';
import Nav from './nav';
import BottomNav, { BOTTOM_NAV_HEIGHT } from './BottomNav';

const APP_BAR_MOBILE = 60;
const APP_BAR_DESKTOP = 68;

const StyledRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
  backgroundColor: theme.palette.background.default,
}));

const Main = styled('div', { shouldForwardProp: (prop) => prop !== 'mobile' })(({ theme, mobile }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 16,
  paddingBottom: mobile ? BOTTOM_NAV_HEIGHT + 24 : theme.spacing(6),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const isMobile = !useResponsive('up', 'lg');

  return (
    <StyledRoot>
      <Header onOpenNav={() => setOpen(true)} />
      <Nav openNav={open} onCloseNav={() => setOpen(false)} />

      <Main mobile={isMobile ? 1 : 0}>
        <Outlet />
      </Main>

      <BottomNav onMore={() => setOpen(true)} />
    </StyledRoot>
  );
}
